(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4549],{

/***/ 92640:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/api",
      function () {
        return __webpack_require__(4626);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97005);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const CustomersMarquee = (param)=>{
    let { customersData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                children: customersData.map((card, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-surface text-black rounded-2xl px-11 py-16 mx-2 flex flex-col justify-between h-[520px] w-[390px] border border-surface-dark",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "bg-surface-dark rounded-md font-semibold px-4 py-2 text-gray-700 uppercase ",
                                    children: card.tag
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "inline-flex justify-center items-center p-3 bg-white rounded-xl border border-surface-dark",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/testimonials/comapnies/").concat(card.logo),
                                        alt: "Company Logo",
                                        className: "h-auto",
                                        width: 100,
                                        height: 100
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[18px] leading-[26px] text-black font-medium mb-6",
                                children: card.quote
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-semibold text-xl",
                                        children: card.author
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-base text-gray-500",
                                        children: card.authorTitle
                                    })
                                ]
                            })
                        ]
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomersMarquee);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 18495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70231);


const GradientCheckIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "gradient",
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "0%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0%",
                            stopColor: "#a855f7"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "50%",
                            stopColor: "#6366f1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "100%",
                            stopColor: "#3b82f6"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_1__/* .FaRegCircleCheck */ .ReY, {
                style: {
                    fill: "url(#gradient)",
                    width: "100%",
                    height: "100%"
                }
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (GradientCheckIcon);


/***/ }),

/***/ 26239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Pricing_ApiAddonPricingCard2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/stripe.js
var stripe = __webpack_require__(42830);
// EXTERNAL MODULE: ./components/v2/Slider/CustomReactSlider.jsx
var CustomReactSlider = __webpack_require__(15662);
// EXTERNAL MODULE: ./utils/signature_owner.js
var signature_owner = __webpack_require__(10447);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 42 modules
var esm = __webpack_require__(62194);
// EXTERNAL MODULE: ./components/v2/Cards/GradientCheckIcon.jsx
var GradientCheckIcon = __webpack_require__(18495);
;// CONCATENATED MODULE: ./components/v2/Slider/CustomBoloSlider2.jsx



const CustomBoloSlider2 = (param)=>{
    let { defaultValue =1000 , min =500 , max =5000 , marks =[
        {
            value: 500,
            label: "500"
        },
        {
            value: 1000,
            label: "1000"
        },
        {
            value: 2000,
            label: "2000"
        },
        {
            value: 5000,
            label: "5000"
        }
    ] , onChange , currentActiveMark =0  } = param;
    const [value, setValue] = (0,react.useState)(defaultValue);
    const [isDragging, setIsDragging] = (0,react.useState)(false);
    const sliderRef = (0,react.useRef)(null);
    const thumbRef = (0,react.useRef)(null);
    // Find the closest mark value to snap to
    const findClosestMark = (currentValue)=>{
        return marks.reduce((closest, mark)=>{
            return Math.abs(mark.value - currentValue) < Math.abs(closest - currentValue) ? mark.value : closest;
        }, marks[0].value);
    };
    // Convert pixel position to value
    const getValueFromPosition = (position)=>{
        if (!sliderRef.current) return min;
        const rect = sliderRef.current.getBoundingClientRect();
        const percentage = (position - rect.left) / rect.width;
        const rawValue = min + (max - min) * Math.max(0, Math.min(1, percentage));
        return Math.round(rawValue);
    };
    // Convert value to percentage for positioning
    const getPercentage = (value)=>{
        if (value === 200) {
            return (value + 80 - min) / (max - min) * 100;
        }
        return (value - min) / (max - min) * 100;
    };
    const handleMouseDown = (e)=>{
        setIsDragging(true);
        const newValue = getValueFromPosition(e.clientX);
        setValue(newValue);
        if (onChange) onChange(newValue);
    };
    const handleMouseMove = (e)=>{
        if (!isDragging) return;
        const newValue = getValueFromPosition(e.clientX);
        setValue(newValue);
        if (onChange) onChange(newValue);
    };
    const handleMouseUp = ()=>{
        if (!isDragging) return;
        setIsDragging(false);
        const snappedValue = findClosestMark(value);
        setValue(snappedValue);
        if (onChange) onChange(snappedValue);
    };
    (0,react.useEffect)(()=>{
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        }
        return ()=>{
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        isDragging,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full py-8 select-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: sliderRef,
            className: "relative w-full h-2 bg-slate-200 cursor-pointer",
            onMouseDown: handleMouseDown,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute h-2 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 ",
                    style: {
                        width: "".concat(getPercentage(value), "%")
                    }
                }),
                marks.map((mark, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            left: "".concat(getPercentage(mark.value), "%")
                        },
                        className: "absolute",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute md:w-1 w-0.5 h-6 rounded-full   -translate-x-1/2 -translate-y-2 ".concat(mark.value <= value ? "bg-primary" : "bg-slate-400", " ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute text-xs -translate-x-1/2 mt-6 flex flex-col gap-1 items-center justify-center ".concat(mark.value <= value ? "text-primary font-bold" : "text-gray-600", " "),
                                children: mark.label
                            })
                        ]
                    }, mark.value)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: thumbRef,
                    className: "absolute w-6 h-6 bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 rounded-full border-[3px] border-white shadow-md cursor-pointer transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-150 top-1/2 ",
                    style: {
                        left: "".concat(getPercentage(value), "%"),
                        transform: "translate(-50%, -50%) scale(".concat(isDragging ? 1.1 : 1, ")")
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Slider_CustomBoloSlider2 = (CustomBoloSlider2);

// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
;// CONCATENATED MODULE: ./components/v2/Pricing/ApiAddonPricingCard2.jsx













const ApiAddonPricingCard2 = (param)=>{
    let { currentPage , title , subTitle , bgColor ="bg-white" , cardBorder  } = param;
    var _featureDataObject_includes_currentPage;
    const [priceLoading, setPriceLoading] = (0,react.useState)(false);
    const featureDataObject = (0,react.useMemo)(()=>{
        return {
            title: "BoloSign API",
            desc: "Automate your signature workflow by integrating our API into your systems.",
            includes: {
                api: [
                    "BoloSign Webhooks",
                    "BoloSign Embeddings"
                ],
                embedding: [
                    "BoloSign Webhooks",
                    "BoloSign API"
                ]
            },
            features: [
                "BoloSign API Access",
                "BoloSign Webhooks",
                "BoloSign Embeddings",
                "Customizable Branding",
                "Session Control",
                "Create PDFs",
                "Send PDFs for signature",
                "Fetch PDF status in your website",
                "Zapier Integration",
                "Pabbly Integration",
                "Make (Integromat) Integration",
                "And more..."
            ]
        };
    }, []);
    const envelopeCountAndPrice = [
        {
            count: 100,
            price: 40
        },
        {
            count: 200,
            price: 72
        },
        {
            count: 500,
            price: 180
        },
        {
            count: 1000,
            price: 360
        },
        {
            count: 2000,
            price: 720
        },
        {
            count: 3000,
            price: "Contact Sales"
        }
    ];
    const [apiPrice, setApiPrice] = (0,react.useState)(envelopeCountAndPrice[1].price);
    const [documentSliderCount, setDocumentSliderCount] = (0,react.useState)(envelopeCountAndPrice[1].count);
    //   const ownerPlanDetails = getOwnerPlanDetails();
    //   const currentPlanTier = ownerPlanDetails?.currentPlan?.tier;
    //   const isCurrentPlanActive = ownerPlanDetails.currentPlan?.isActive;
    const handleSliderChange = (newValue)=>{
        setDocumentSliderCount(newValue);
        const selectedPrice = envelopeCountAndPrice.find((item)=>item.count === newValue);
        if (selectedPrice) {
            setApiPrice(selectedPrice.price);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " flex flex-col gap-y-2 w-full lg:p-6 p-4 md:p-10 border-2 border-slate-200 rounded-3xl relative mb-20 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl font-bold text-left",
                        children: title || featureDataObject.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base text-left text-gray-600 mt-4 ",
                        children: subTitle || featureDataObject.desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex md:gap-8 gap-2 mt-4 lg:flex-row flex-col",
                        children: (_featureDataObject_includes_currentPage = featureDataObject.includes[currentPage]) === null || _featureDataObject_includes_currentPage === void 0 ? void 0 : _featureDataObject_includes_currentPage.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base leading-[24px] font-semibold  mb-1",
                                        children: item
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "space-y-2 min-h-[100px]",
                    children: apiPrice === "Contact Sales" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start items-center w-full min-h-[100px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-5xl font-bold text-black",
                            children: "Contact Sales"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-start items-end w-full h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-6xl font-bold",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-4xl mr-1",
                                                children: "$"
                                            }),
                                            apiPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-2xl ml-1",
                                        children: "/mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-left text-base text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-gray-700",
                                        children: "$0.5"
                                    }),
                                    " for each document beyond",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-semibold text-gray-700 mx-1",
                                        children: documentSliderCount
                                    }),
                                    "limit."
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider_CustomBoloSlider2, {
                    defaultValue: documentSliderCount,
                    min: 100,
                    max: 3000,
                    marks: envelopeCountAndPrice.map((item)=>({
                            value: item.count,
                            label: "".concat(item.count)
                        })),
                    onChange: handleSliderChange,
                    currentActiveMark: 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex justify-start items-center gap-3 md:flex-row flex-col my-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary1 */.au, {
                        buttonText: apiPrice === "Contact Sales" ? "Contact Sales" : "Subscribe Now",
                        className: "w-full md:w-auto",
                        onClick: async ()=>{
                            if (apiPrice === "Contact Sales") {
                                window === null || window === void 0 ? void 0 : window.Intercom("showNewMessage");
                            } else {
                                setPriceLoading(true);
                                await (0,stripe.createAPITierSubscriptions)({
                                    documentsCount: documentSliderCount
                                });
                                setPriceLoading(false);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMSecondaryBorder */.kL, {
                        className: "w-full md:w-auto",
                        onClick: ()=>{
                            window.open("https://signature.boloforms.com/register?from=API_PAGE".concat((0,signature_owner/* createUTMQueryParams */.T0)({
                                from: "API_PAGE"
                            })), "_self");
                        },
                        buttonText: "Try Sandbox Testing for $0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
                children: featureDataObject.features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientCheckIcon/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base leading-[24px] font-medium  ",
                                children: feature
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var Pricing_ApiAddonPricingCard2 = (ApiAddonPricingCard2);


/***/ }),

/***/ 95291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ industryLeadersCard; }
/* harmony export */ });
// export const industryLeadersCard = [
//   {
//     tag: "1. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "Simple, straight to the point, with a lot of new features coming up. Great!",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "2. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     subTitle: "",
//     subDesc: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "3. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "4. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "5. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "6. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "7. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "8. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
// ];
const industryLeadersCard = [
    {
        tag: "marketplace",
        logo: "greenleaf.png",
        quote: "Simple, straight to the point, with a lot of new features coming up. Great!",
        author: "Jonathan S.",
        authorTitle: "Marketing Manager"
    },
    {
        tag: "fintech",
        logo: "elemenopillows.png",
        quote: "BoloForms transformed document signing with a user-friendly interface, secure e-signatures, and seamless customization, streamlining our procedures.",
        author: "Juan Diego P.",
        authorTitle: "Operations Executive"
    },
    {
        tag: "marketplace",
        logo: "techsolutions.png",
        quote: "It's cheap and it just works! I had to do mass signatures of our team members and Boloforms made it easy for us to get signatures from our team faster.",
        author: "Sam K.",
        authorTitle: "Sales Lead"
    },
    {
        tag: "fintech",
        logo: "freshstart.png",
        quote: "Finally a simple to use yet full featured PDF signature app!",
        author: "Lisa Brown",
        authorTitle: "Owner"
    },
    {
        tag: "delivery",
        logo: "rappi.png",
        quote: "BoloForms made our document workflows seamless. The intuitive interface and reliable e-signatures significantly improved our team’s efficiency.",
        author: "Groham ",
        authorTitle: "Head of Product"
    }
];


/***/ }),

/***/ 4626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(69274);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(5434);
/* harmony import */ var react_icons_tb__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(37106);
/* harmony import */ var react_icons_pi__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(96225);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(60155);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(63750);
/* harmony import */ var react_icons_tfi__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(81873);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70231);
/* harmony import */ var react_icons_cg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(80471);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(8193);
/* harmony import */ var react_icons_si__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(97735);
/* harmony import */ var _components_Pricing_ApiAddonPricingCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8054);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43138);
/* harmony import */ var _components_Slider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24747);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59183);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86585);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46687);
/* harmony import */ var _components_Cards_PricingCards__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33103);
/* harmony import */ var _components_Subscribe__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18034);
/* harmony import */ var _components_Cards_ClientsTestimonial__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59471);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10447);
/* harmony import */ var components_customers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43155);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56475);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74791);
/* harmony import */ var components_CLM_Customers__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5297);
/* harmony import */ var _constants_customersData__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95291);
/* harmony import */ var _components_Pricing_ApiAddonPricingCard2__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26239);





































const customerImages = (/* unused pure expression or super */ null && ([
    "company1.png",
    "company2.png",
    "company3.png",
    "company4.png",
    "company5.png",
    "company6.png",
    "company7.png"
]));
const developerFriendlyApi = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_cg__WEBPACK_IMPORTED_MODULE_21__/* .CgTerminal */ .ua_, {}),
        title: "Easily integrate BoloSign into your existing workflows",
        description: "Build solutions with zero assistance with our extensive documentation, how-to guides, and real examples. Test your API calls with 7 days free trial.",
        bgColor: "bg-accent-orange"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_22__/* .FaUserShield */ .KE5, {}),
        title: "Keep your data protected with top-tier security",
        description: "Signature, along with the corresponding documentation, are stored in a secure infrastructure. Our e-Signature software is E-SIGN, UETA and HIPAA compliant. It's also backed by SOC 2 certification so you can sign with total confidence.",
        bgColor: "bg-accent-blue"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_pi__WEBPACK_IMPORTED_MODULE_23__/* .PiChatsLight */ .l_A, {}),
        title: "Stay in the loop with Developer Dashboard",
        description: "Elevate your development experience with our Developer Center. Monitor production data in real-time, maintain a comprehensive history of webhooks and keep track of request and response times for optimal performance.",
        bgColor: "bg-accent-pink"
    }
];
const cardsData = [
    {
        title: "REST API",
        description: "Utilize the power of our REST API for seamless integration and outstanding performance.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_24__/* .TbApi */ .jp8, {}),
        bgColor: "bg-orange-100",
        iconColor: "bg-orange-500"
    },
    {
        title: "Webhooks",
        description: "Enhance your workflow with our reliable webhooks for real-time data updates and automation.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_pi__WEBPACK_IMPORTED_MODULE_23__/* .PiWebhooksLogo */ .OH7, {}),
        bgColor: "bg-fuchsia-100",
        iconColor: "bg-fuchsia-500"
    },
    {
        title: "HTML to PDF",
        description: "Create fillable document forms using our HTML API with precise and rich styling capabilities.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_pi__WEBPACK_IMPORTED_MODULE_23__/* .PiFileHtml */ .jLZ, {}),
        bgColor: "bg-green-100",
        iconColor: "bg-green-500"
    }
];
const restAPiCards = [
    {
        title: "Templates",
        description: "Send documents with pre-filled fields and create templates for future use.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_25__/* .IoDocumentTextOutline */ .jyt, {}),
        bgColor: "bg-sky-500"
    },
    {
        title: "Submissions",
        description: "Create new submissions to request signatures and load data about completed submissions.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_26__/* .BsPersonPlus */ .im1, {}),
        bgColor: "bg-green-500"
    },
    {
        title: "Webhooks",
        description: "Analyse document signing events for each individual submission.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_25__/* .IoSearchOutline */ .uFR, {}),
        bgColor: "bg-orange-500"
    },
    {
        title: "Documents",
        description: "Download signed documents via URLs provided by the API.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tfi__WEBPACK_IMPORTED_MODULE_27__/* .TfiDownload */ .YOW, {}),
        bgColor: "bg-red-500"
    }
];
const faqs = [
    {
        id: 1,
        question: "Which plan do I need to be on to get API access?",
        answer: "Please see above pricing section."
    },
    {
        id: 2,
        question: "How will I be charged for API usage?",
        answer: "Once you subscribe to a plan according to your needs, you will be charged according to the plan till the usage already defined in it. If number of requests exceds the limit you would be charged .5$/doc extra at the end of billing cycle."
    },
    {
        id: 3,
        question: "What is the response time for API calls?",
        answer: "The response time for API calls is dependent on the server load and the complexity of the request. However, the average response time is less than 200ms."
    },
    {
        id: 4,
        question: "Do I get embed with API?",
        answer: "BoloSign Embed is included in API plan. It is another way of sending documents from your system just like API. Pricings are same to the API plans"
    },
    {
        id: 5,
        question: "Do you provide a sandbox environment for testing?",
        answer: "Yes we provide sandbox environment in our 7 days free trial. You can test your API calls in the sandbox environment before going live by signing up in our dashboard. In case you need more time, you can request for it by contacting our support team from the chat or emailing us at support@boloforms.com"
    }
];
const resources = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_22__/* .FaBookOpen */ .uYZ, {
            className: "text-4xl"
        }),
        title: "API Reference",
        description: "See all of the API methods, grouped by functionality.",
        link: "https://developer.boloforms.com/",
        bgColor: "bg-accent-green"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_28__/* .AiOutlineNodeIndex */ .xgE, {
            className: "text-4xl"
        }),
        title: "OpenAPI Specification",
        description: "Explore BoloSign API specification.",
        link: "https://developer.boloforms.com/",
        bgColor: "bg-accent-blue"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_si__WEBPACK_IMPORTED_MODULE_29__/* .SiPostman */ .nB$, {
            className: "text-5xl"
        }),
        title: "Postman Collection",
        description: "Run sample requests, test sequences.",
        link: "https://developer.boloforms.com/",
        bgColor: "bg-accent-pink"
    }
];
const codeSnapData = [
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "<signature-field>",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "</signature-field>"
            ]
        })
    },
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                '<text-field name="City">',
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "</text-field>"
            ]
        })
    },
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "<date-field>",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "</date-field>"
            ]
        })
    }
];
const apiFreePricing = {
    title: "Sandbox Testing",
    description: "Send 20 documents via API. Request more via chat.",
    price: 0,
    pricingType: "mo",
    priceDetail: "",
    featuresIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_30__/* .MdStars */ .gms, {}),
    recommended: false,
    features: [
        "20 Documents Included"
    ]
};
const apiYearlyPricing = {
    title: "API",
    description: "Automate your signature workflow by integrating our API into your systems.",
    price: 20,
    pricingType: "mo",
    priceDetail: "+ $0.2/document",
    featuresIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_30__/* .MdStars */ .gms, {}),
    recommended: false,
    features: [
        "100 Documents/mo Included",
        "$0.2 per Document Sent",
        "Can be purchased with any plan"
    ]
};
const API = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign - AI for Smart Contract Management | API"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Automate your signature workflow with Bolosign's powerful and easy-to-use API."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "esignature, e-signature, digital signature, api, boloforms, bolosign, api documentation, api reference, webhooks, html to pdf, rest api"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/api/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign - AI for Smart Contract Management | API"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Automate your signature workflow with Bolosign's powerful and easy-to-use API."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/api/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign - AI for Smart Contract Management | API"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Automate your signature workflow with Bolosign's powerful and easy-to-use API."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/api/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-dark text-white w-full xl:h-[min(750px,calc(100vh-110px))] grid place-items-center ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-screen-xl w-full h-full px-2 sm:px-4 flex flex-col lg:flex-row items-center justify-center gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 py-6 sm:py-10 text-center lg:text-left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full max-w-screen-mxl mx-auto px-4 lg:px-8 xxl:px-0 flex flex-col gap-4 sm:gap-5",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        className: "text-4xl sm:text-6xl font-bold leading-tight",
                                        children: [
                                            "BoloSign",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent",
                                                children: "API"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "w-full text-lg sm:text-xl font-medium",
                                        children: "Start for free and pay only for what you use."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "w-full text-lg max-w-screen-md mx-auto",
                                        children: "BoloSign provides a powerful and easy-to-use API to implement eSigning automation workflows for businesses. Try it now for free, no CC required."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center lg:justify-start flex-wrap gap-6 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_16__/* .CLMButtonPrimary */ .IS, {
                                                buttonText: "Get API Key",
                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_31__/* .HiOutlineKey */ .zpg, {}),
                                                buttonUrl: "https://signature.boloforms.com/settings?type=DEV_SEC&subType=APIKEY&from=API_PAGE"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_16__/* .CLMButtonSecondaryBorder */ .AL, {
                                                buttonText: "Documentation",
                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_30__/* .MdLibraryBooks */ .dBs, {}),
                                                buttonUrl: "https://developer.boloforms.com/"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-1 py-6 justify-end",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: __webpack_require__(80460),
                                alt: "hero",
                                width: 400,
                                height: 400,
                                className: "w-full object-contain sm:scale-110 lg:scale-100 xl:scale-110 h-full aspect-square max-w-md lg:max-w-lg max-h-[min(600px,calc(100vh-200px))] xl:min-h-[450px] rounded-xl overflow-hidden"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "px-4 lg:px-8 py-20 md:py-28",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "max-w-5xl mx-auto text-3xl sm:text-5xl font-bold text-center mb-10 sm:mb-16",
                        children: "Pricing and Features"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "max-w-screen-xl mx-auto md:px-8 px-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Pricing_ApiAddonPricingCard2__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            currentPage: "api"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "w-full py-20 bg-dark",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[1280px] max-w-full mx-auto ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_customers__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "mt-32 max-w-screen-xl mx-auto px-2 sm:px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "max-w-5xl mx-auto text-3xl sm:text-5xl font-bold text-center",
                        children: "Leverage BoloSign's developer-friendly API to create the perfect solution"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full",
                        children: developerFriendlyApi.map((card, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: " px-6 py-8 rounded-xl border border-surface-dark bg-surface-light  transition-all duration-500 ease-in-out",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-16 h-16 flex rounded-full text-6xl",
                                        children: card.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-2xl font-semibold mt-4 mb-3",
                                        children: card.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-base",
                                        children: card.description
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col gap-16 md:gap-4 w-full max-w-screen-xl mx-auto mt-20 sm:mt-40 px-4 lg:px-8 xxl:px-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full flex flex-col lg:flex-row justify-between items-center gap-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                heading2: "API and Webhooks",
                                paragraph: "Discover the capabilities of our API, designed to effortlessly integrate data, automate tasks, and simplify document signing and processing.",
                                buttonPrimaryText: "API Reference",
                                buttonPrimaryUrl: "https://developer.boloforms.com/",
                                buttonSecondaryText: "Webhooks Reference",
                                buttonSecondaryUrl: "https://developer.boloforms.com/webhooks/how-to-add-webhooks"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-2xl mx-auto flex-1 w-full grid grid-cols-1 sm:grid-cols-2 gap-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-sm sm:max-w-none mx-auto flex flex-col gap-6",
                                    children: restAPiCards.slice(0, 2).map((card, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex flex-col px-6 py-8 rounded-xl border-surface-dark bg-surface-light    text-black border-2  transition-all duration-500 ease-in-out",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-16 h-16 sm:w-20 sm:h-20 bg-white flex items-center justify-center text-black text-3xl border border-surface-dark rounded-lg ",
                                                    children: card.icon
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-xl font-semibold mt-4 mb-3",
                                                    children: card.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-base",
                                                    children: card.description
                                                })
                                            ]
                                        }, index))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-sm sm:max-w-none mx-auto flex flex-col gap-6 justify-end",
                                    children: restAPiCards.slice(2, 4).map((card, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex flex-col px-6 py-8 rounded-xl border-surface-dark bg-surface-light    text-black border-2  transition-all duration-500 ease-in-out",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-16 h-16 sm:w-20 sm:h-20 bg-white flex items-center justify-center text-black text-3xl border border-surface-dark rounded-lg ",
                                                    children: card.icon
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-xl font-semibold mt-4 mb-3",
                                                    children: card.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-base",
                                                    children: card.description
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "bg-surface-dark py-20 mt-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[1280px] max-w-full mx-auto pb-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                            className: "text-4xl md:text-5xl md:text-left text-center font-semibold text-black",
                            children: [
                                "Industry leaders fly with BoloSign. ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " It's your turn to rise with AI."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_Customers__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        customersData: _constants_customersData__WEBPACK_IMPORTED_MODULE_19__/* .industryLeadersCard */ .Z
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "mt-20 max-w-screen-xl mx-auto px-4 md:px-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "md:w-2/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            heading2: "Start leveraging the unique features of BoloSign API today",
                            paragraph: "Access functionalities that set us apart from the competition. We offer a range of unique features tailored to meet your needs."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-4 xl:mt-8 grid md:grid-cols-3 gap-4 sm:gap-10",
                        children: resources.map((feature, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                className: "block group w-[min(90vw,400px)] mx-auto md:w-auto md:mx-0 border  rounded-2xl transition-all duration-500 ease-in-out border-surface-dark bg-surface hover:bg-surface-light",
                                href: feature.link,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "h-full flex flex-col space-y-6 p-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "bg-white text-black rounded-full w-20 h-20 flex items-center justify-center border border-surface-dark",
                                                children: feature.icon
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "h-full flex flex-col justify-between space-y-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-xl font-semibold text-neutral-700 transition group-hover:text-secondary-focus",
                                                            children: feature.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-neutral-600",
                                                            children: feature.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_16__/* .CLMButtonPrimaryArrow */ .t3, {
                                                        buttonText: "Learn more"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-surface-light text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    faqData: faqs,
                    heading: "Frequently Asked Questions"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (API);
const MiniCodeSnap = (param)=>{
    let { code  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "rounded-xl bg-black py-3 px-4 w-[300px]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center gap-2",
                        children: Array.from({
                            length: 3
                        }, (_, index)=>/*#__PURE__*/ _jsx("div", {
                                className: "w-2 h-2 rounded-full bg-gray-200"
                            }, index))
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2 text-white cursor-pointer",
                        children: [
                            /*#__PURE__*/ _jsx(IoCopyOutline, {}),
                            " COPY"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-3",
                children: /*#__PURE__*/ _jsx("pre", {
                    className: "text-yellow-300 text-md",
                    children: code
                })
            })
        ]
    });
};
const ApiPricingCard = (param)=>{
    let { title , titleColor , planType , price , description , buttonText , buttonUrl  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full lg:w-[450px] bg-pink-100 px-8 py-8 rounded-xl flex flex-col gap-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-4",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-2xl sm:text-3xl font-semibold ".concat(titleColor),
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-2 h-2 rounded-full bg-black"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-3xl font-semibold text-black",
                        children: planType
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-3 items-end",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-5xl font-bold",
                        children: price
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-gray-900 text-lg",
                        children: "/ document"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-gray-900 text-base",
                children: description
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-2",
                children: /*#__PURE__*/ _jsx(RoundButton, {
                    buttonText: buttonText,
                    buttonUrl: buttonUrl
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,1057,7627,3415,6158,8907,955,1086,9642,1357,5991,9471,3103,273,9995,9774,2888,179], function() { return __webpack_exec__(92640); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);